// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* font size */
/* font weight*/
/* box shadow*/
/* radius*/
/* spacer*/
/* margin 2px */
.m1 {
  margin: 2px;
}

.ml1 {
  margin-left: 2px;
}

.mr1 {
  margin-right: 2px;
}

.mt1 {
  margin-top: 2px;
}

.mb1 {
  margin-bottom: 2px;
}

.mx1 {
  margin-left: 2px;
  margin-right: 2px;
}

.my1 {
  margin-top: 2px;
  margin-bottom: 2px;
}

/* margin 4px */
.m2 {
  margin: 4px;
}

.ml2 {
  margin-left: 4px;
}

.mr2 {
  margin-right: 4px;
}

.mt2 {
  margin-top: 4px;
}

.mb2 {
  margin-bottom: 4px;
}

.mx2 {
  margin-left: 4px;
  margin-right: 4px;
}

.my2 {
  margin-top: 4px;
  margin-bottom: 4px;
}

/* margin 6px */
.m3 {
  margin: 6px;
}

.ml3 {
  margin-left: 6px;
}

.mr3 {
  margin-right: 6px;
}

.mt3 {
  margin-top: 6px;
}

.mb3 {
  margin-bottom: 6px;
}

.mx3 {
  margin-left: 6px;
  margin-right: 6px;
}

.my3 {
  margin-top: 6px;
  margin-bottom: 6px;
}

/* margin 8px */
.m4 {
  margin: 8px;
}

.ml4 {
  margin-left: 8px;
}

.mr4 {
  margin-right: 8px;
}

.mt4 {
  margin-top: 8px;
}

.mb4 {
  margin-bottom: 8px;
}

.mx4 {
  margin-left: 8px;
  margin-right: 8px;
}

.my4 {
  margin-top: 8px;
  margin-bottom: 8px;
}

/* margin 10px */
.m5 {
  margin: 10px;
}

.ml5 {
  margin-left: 10px;
}

.mr5 {
  margin-right: 10px;
}

.mt5 {
  margin-top: 10px;
}

.mb5 {
  margin-bottom: 10px;
}

.mx5 {
  margin-left: 10px;
  margin-right: 10px;
}

.my5 {
  margin-top: 10px;
  margin-bottom: 10px;
}

/* margin 12px */
.m6 {
  margin: 12px;
}

.ml6 {
  margin-left: 12px;
}

.mr6 {
  margin-right: 12px;
}

.mt6 {
  margin-top: 12px;
}

.mb6 {
  margin-bottom: 12px;
}

.mx6 {
  margin-left: 12px;
  margin-right: 12px;
}

.my6 {
  margin-top: 12px;
  margin-bottom: 12px;
}

/* margin 14px */
.m7 {
  margin: 14px;
}

.ml7 {
  margin-left: 14px;
}

.mr7 {
  margin-right: 14px;
}

.mt7 {
  margin-top: 14px;
}

.mb7 {
  margin-bottom: 14px;
}

.mx7 {
  margin-left: 14px;
  margin-right: 14px;
}

.my7 {
  margin-top: 14px;
  margin-bottom: 14px;
}

/* margin 16px */
.m8 {
  margin: 16px;
}

.ml8 {
  margin-left: 16px;
}

.mr8 {
  margin-right: 16px;
}

.mt8 {
  margin-top: 16px;
}

.mb8 {
  margin-bottom: 16px;
}

.mx8 {
  margin-left: 16px;
  margin-right: 16px;
}

.my8 {
  margin-top: 16px;
  margin-bottom: 16px;
}

/* margin 18px */
.m9 {
  margin: 18px;
}

.ml9 {
  margin-left: 18px;
}

.mr9 {
  margin-right: 18px;
}

.mt9 {
  margin-top: 18px;
}

.mb9 {
  margin-bottom: 18px;
}

.mx9 {
  margin-left: 18px;
  margin-right: 18px;
}

.my9 {
  margin-top: 18px;
  margin-bottom: 18px;
}

/* margin 20px */
.m10 {
  margin: 20px;
}

.ml10 {
  margin-left: 20px;
}

.mr10 {
  margin-right: 20px;
}

.mt10 {
  margin-top: 20px;
}

.mb10 {
  margin-bottom: 20px;
}

.mx10 {
  margin-left: 20px;
  margin-right: 20px;
}

.my10 {
  margin-top: 20px;
  margin-bottom: 20px;
}

/* margin 22px */
.m11 {
  margin: 22px;
}

.ml11 {
  margin-left: 22px;
}

.mr11 {
  margin-right: 22px;
}

.mt11 {
  margin-top: 22px;
}

.mb11 {
  margin-bottom: 22px;
}

.mx11 {
  margin-left: 22px;
  margin-right: 22px;
}

.my11 {
  margin-top: 22px;
  margin-bottom: 22px;
}

/* margin 24px */
.m12 {
  margin: 24px;
}

.ml12 {
  margin-left: 24px;
}

.mr12 {
  margin-right: 24px;
}

.mt12 {
  margin-top: 24px;
}

.mb12 {
  margin-bottom: 24px;
}

.mx12 {
  margin-left: 24px;
  margin-right: 24px;
}

.my12 {
  margin-top: 24px;
  margin-bottom: 24px;
}

/* margin 26px */
.m13 {
  margin: 26px;
}

.ml13 {
  margin-left: 26px;
}

.mr13 {
  margin-right: 26px;
}

.mt13 {
  margin-top: 26px;
}

.mb13 {
  margin-bottom: 26px;
}

.mx13 {
  margin-left: 26px;
  margin-right: 26px;
}

.my13 {
  margin-top: 26px;
  margin-bottom: 26px;
}

/* margin 28px */
.m14 {
  margin: 28px;
}

.ml14 {
  margin-left: 28px;
}

.mr14 {
  margin-right: 28px;
}

.mt14 {
  margin-top: 28px;
}

.mb14 {
  margin-bottom: 28px;
}

.mx14 {
  margin-left: 28px;
  margin-right: 28px;
}

.my14 {
  margin-top: 28px;
  margin-bottom: 28px;
}

/* margin 30px */
.m15 {
  margin: 30px;
}

.ml15 {
  margin-left: 30px;
}

.mr15 {
  margin-right: 30px;
}

.mt15 {
  margin-top: 30px;
}

.mb15 {
  margin-bottom: 30px;
}

.mx15 {
  margin-left: 30px;
  margin-right: 30px;
}

.my15 {
  margin-top: 30px;
  margin-bottom: 30px;
}

/* margin 32px */
.m16 {
  margin: 32px;
}

.ml16 {
  margin-left: 32px;
}

.mr16 {
  margin-right: 32px;
}

.mt16 {
  margin-top: 32px;
}

.mb16 {
  margin-bottom: 32px;
}

.mx16 {
  margin-left: 32px;
  margin-right: 32px;
}

.my16 {
  margin-top: 32px;
  margin-bottom: 32px;
}

/* margin 34px */
.m17 {
  margin: 34px;
}

.ml17 {
  margin-left: 34px;
}

.mr17 {
  margin-right: 34px;
}

.mt17 {
  margin-top: 34px;
}

.mb17 {
  margin-bottom: 34px;
}

.mx17 {
  margin-left: 34px;
  margin-right: 34px;
}

.my17 {
  margin-top: 34px;
  margin-bottom: 34px;
}

/* margin 36px */
.m18 {
  margin: 36px;
}

.ml18 {
  margin-left: 36px;
}

.mr18 {
  margin-right: 36px;
}

.mt18 {
  margin-top: 36px;
}

.mb18 {
  margin-bottom: 36px;
}

.mx18 {
  margin-left: 36px;
  margin-right: 36px;
}

.my18 {
  margin-top: 36px;
  margin-bottom: 36px;
}

/* margin 38px */
.m19 {
  margin: 38px;
}

.ml19 {
  margin-left: 38px;
}

.mr19 {
  margin-right: 38px;
}

.mt19 {
  margin-top: 38px;
}

.mb19 {
  margin-bottom: 38px;
}

.mx19 {
  margin-left: 38px;
  margin-right: 38px;
}

.my19 {
  margin-top: 38px;
  margin-bottom: 38px;
}

/* margin 40px */
.m20 {
  margin: 40px;
}

.ml20 {
  margin-left: 40px;
}

.mr20 {
  margin-right: 40px;
}

.mt20 {
  margin-top: 40px;
}

.mb20 {
  margin-bottom: 40px;
}

.mx20 {
  margin-left: 40px;
  margin-right: 40px;
}

.my20 {
  margin-top: 40px;
  margin-bottom: 40px;
}

/* margin 42px */
.m21 {
  margin: 42px;
}

.ml21 {
  margin-left: 42px;
}

.mr21 {
  margin-right: 42px;
}

.mt21 {
  margin-top: 42px;
}

.mb21 {
  margin-bottom: 42px;
}

.mx21 {
  margin-left: 42px;
  margin-right: 42px;
}

.my21 {
  margin-top: 42px;
  margin-bottom: 42px;
}

/* margin 44px */
.m22 {
  margin: 44px;
}

.ml22 {
  margin-left: 44px;
}

.mr22 {
  margin-right: 44px;
}

.mt22 {
  margin-top: 44px;
}

.mb22 {
  margin-bottom: 44px;
}

.mx22 {
  margin-left: 44px;
  margin-right: 44px;
}

.my22 {
  margin-top: 44px;
  margin-bottom: 44px;
}

/* margin 46px */
.m23 {
  margin: 46px;
}

.ml23 {
  margin-left: 46px;
}

.mr23 {
  margin-right: 46px;
}

.mt23 {
  margin-top: 46px;
}

.mb23 {
  margin-bottom: 46px;
}

.mx23 {
  margin-left: 46px;
  margin-right: 46px;
}

.my23 {
  margin-top: 46px;
  margin-bottom: 46px;
}

/* margin 48px */
.m24 {
  margin: 48px;
}

.ml24 {
  margin-left: 48px;
}

.mr24 {
  margin-right: 48px;
}

.mt24 {
  margin-top: 48px;
}

.mb24 {
  margin-bottom: 48px;
}

.mx24 {
  margin-left: 48px;
  margin-right: 48px;
}

.my24 {
  margin-top: 48px;
  margin-bottom: 48px;
}

/* margin 50px */
.m25 {
  margin: 50px;
}

.ml25 {
  margin-left: 50px;
}

.mr25 {
  margin-right: 50px;
}

.mt25 {
  margin-top: 50px;
}

.mb25 {
  margin-bottom: 50px;
}

.mx25 {
  margin-left: 50px;
  margin-right: 50px;
}

.my25 {
  margin-top: 50px;
  margin-bottom: 50px;
}

/* margin 52px */
.m26 {
  margin: 52px;
}

.ml26 {
  margin-left: 52px;
}

.mr26 {
  margin-right: 52px;
}

.mt26 {
  margin-top: 52px;
}

.mb26 {
  margin-bottom: 52px;
}

.mx26 {
  margin-left: 52px;
  margin-right: 52px;
}

.my26 {
  margin-top: 52px;
  margin-bottom: 52px;
}

/* margin 54px */
.m27 {
  margin: 54px;
}

.ml27 {
  margin-left: 54px;
}

.mr27 {
  margin-right: 54px;
}

.mt27 {
  margin-top: 54px;
}

.mb27 {
  margin-bottom: 54px;
}

.mx27 {
  margin-left: 54px;
  margin-right: 54px;
}

.my27 {
  margin-top: 54px;
  margin-bottom: 54px;
}

/* margin 56px */
.m28 {
  margin: 56px;
}

.ml28 {
  margin-left: 56px;
}

.mr28 {
  margin-right: 56px;
}

.mt28 {
  margin-top: 56px;
}

.mb28 {
  margin-bottom: 56px;
}

.mx28 {
  margin-left: 56px;
  margin-right: 56px;
}

.my28 {
  margin-top: 56px;
  margin-bottom: 56px;
}

/* margin 58px */
.m29 {
  margin: 58px;
}

.ml29 {
  margin-left: 58px;
}

.mr29 {
  margin-right: 58px;
}

.mt29 {
  margin-top: 58px;
}

.mb29 {
  margin-bottom: 58px;
}

.mx29 {
  margin-left: 58px;
  margin-right: 58px;
}

.my29 {
  margin-top: 58px;
  margin-bottom: 58px;
}

/* margin 60px */
.m30 {
  margin: 60px;
}

.ml30 {
  margin-left: 60px;
}

.mr30 {
  margin-right: 60px;
}

.mt30 {
  margin-top: 60px;
}

.mb30 {
  margin-bottom: 60px;
}

.mx30 {
  margin-left: 60px;
  margin-right: 60px;
}

.my30 {
  margin-top: 60px;
  margin-bottom: 60px;
}

/* padding 2px */
.p1 {
  padding: 2px;
}

.pl1 {
  padding-left: 2px;
}

.pr1 {
  padding-right: 2px;
}

.pt1 {
  padding-top: 2px;
}

.pb1 {
  padding-bottom: 2px;
}

.px1 {
  padding-left: 2px;
  padding-right: 2px;
}

.py1 {
  padding-top: 2px;
  padding-bottom: 2px;
}

/* padding 4px */
.p2 {
  padding: 4px;
}

.pl2 {
  padding-left: 4px;
}

.pr2 {
  padding-right: 4px;
}

.pt2 {
  padding-top: 4px;
}

.pb2 {
  padding-bottom: 4px;
}

.px2 {
  padding-left: 4px;
  padding-right: 4px;
}

.py2 {
  padding-top: 4px;
  padding-bottom: 4px;
}

/* padding 6px */
.p3 {
  padding: 6px;
}

.pl3 {
  padding-left: 6px;
}

.pr3 {
  padding-right: 6px;
}

.pt3 {
  padding-top: 6px;
}

.pb3 {
  padding-bottom: 6px;
}

.px3 {
  padding-left: 6px;
  padding-right: 6px;
}

.py3 {
  padding-top: 6px;
  padding-bottom: 6px;
}

/* padding 8px */
.p4 {
  padding: 8px;
}

.pl4 {
  padding-left: 8px;
}

.pr4 {
  padding-right: 8px;
}

.pt4 {
  padding-top: 8px;
}

.pb4 {
  padding-bottom: 8px;
}

.px4 {
  padding-left: 8px;
  padding-right: 8px;
}

.py4 {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* padding 10px */
.p5 {
  padding: 10px;
}

.pl5 {
  padding-left: 10px;
}

.pr5 {
  padding-right: 10px;
}

.pt5 {
  padding-top: 10px;
}

.pb5 {
  padding-bottom: 10px;
}

.px5 {
  padding-left: 10px;
  padding-right: 10px;
}

.py5 {
  padding-top: 10px;
  padding-bottom: 10px;
}

/* padding 12px */
.p6 {
  padding: 12px;
}

.pl6 {
  padding-left: 12px;
}

.pr6 {
  padding-right: 12px;
}

.pt6 {
  padding-top: 12px;
}

.pb6 {
  padding-bottom: 12px;
}

.px6 {
  padding-left: 12px;
  padding-right: 12px;
}

.py6 {
  padding-top: 12px;
  padding-bottom: 12px;
}

/* padding 14px */
.p7 {
  padding: 14px;
}

.pl7 {
  padding-left: 14px;
}

.pr7 {
  padding-right: 14px;
}

.pt7 {
  padding-top: 14px;
}

.pb7 {
  padding-bottom: 14px;
}

.px7 {
  padding-left: 14px;
  padding-right: 14px;
}

.py7 {
  padding-top: 14px;
  padding-bottom: 14px;
}

/* padding 16px */
.p8 {
  padding: 16px;
}

.pl8 {
  padding-left: 16px;
}

.pr8 {
  padding-right: 16px;
}

.pt8 {
  padding-top: 16px;
}

.pb8 {
  padding-bottom: 16px;
}

.px8 {
  padding-left: 16px;
  padding-right: 16px;
}

.py8 {
  padding-top: 16px;
  padding-bottom: 16px;
}

/* padding 18px */
.p9 {
  padding: 18px;
}

.pl9 {
  padding-left: 18px;
}

.pr9 {
  padding-right: 18px;
}

.pt9 {
  padding-top: 18px;
}

.pb9 {
  padding-bottom: 18px;
}

.px9 {
  padding-left: 18px;
  padding-right: 18px;
}

.py9 {
  padding-top: 18px;
  padding-bottom: 18px;
}

/* padding 20px */
.p10 {
  padding: 20px;
}

.pl10 {
  padding-left: 20px;
}

.pr10 {
  padding-right: 20px;
}

.pt10 {
  padding-top: 20px;
}

.pb10 {
  padding-bottom: 20px;
}

.px10 {
  padding-left: 20px;
  padding-right: 20px;
}

.py10 {
  padding-top: 20px;
  padding-bottom: 20px;
}

/* padding 22px */
.p11 {
  padding: 22px;
}

.pl11 {
  padding-left: 22px;
}

.pr11 {
  padding-right: 22px;
}

.pt11 {
  padding-top: 22px;
}

.pb11 {
  padding-bottom: 22px;
}

.px11 {
  padding-left: 22px;
  padding-right: 22px;
}

.py11 {
  padding-top: 22px;
  padding-bottom: 22px;
}

/* padding 24px */
.p12 {
  padding: 24px;
}

.pl12 {
  padding-left: 24px;
}

.pr12 {
  padding-right: 24px;
}

.pt12 {
  padding-top: 24px;
}

.pb12 {
  padding-bottom: 24px;
}

.px12 {
  padding-left: 24px;
  padding-right: 24px;
}

.py12 {
  padding-top: 24px;
  padding-bottom: 24px;
}

/* padding 26px */
.p13 {
  padding: 26px;
}

.pl13 {
  padding-left: 26px;
}

.pr13 {
  padding-right: 26px;
}

.pt13 {
  padding-top: 26px;
}

.pb13 {
  padding-bottom: 26px;
}

.px13 {
  padding-left: 26px;
  padding-right: 26px;
}

.py13 {
  padding-top: 26px;
  padding-bottom: 26px;
}

/* padding 28px */
.p14 {
  padding: 28px;
}

.pl14 {
  padding-left: 28px;
}

.pr14 {
  padding-right: 28px;
}

.pt14 {
  padding-top: 28px;
}

.pb14 {
  padding-bottom: 28px;
}

.px14 {
  padding-left: 28px;
  padding-right: 28px;
}

.py14 {
  padding-top: 28px;
  padding-bottom: 28px;
}

/* padding 30px */
.p15 {
  padding: 30px;
}

.pl15 {
  padding-left: 30px;
}

.pr15 {
  padding-right: 30px;
}

.pt15 {
  padding-top: 30px;
}

.pb15 {
  padding-bottom: 30px;
}

.px15 {
  padding-left: 30px;
  padding-right: 30px;
}

.py15 {
  padding-top: 30px;
  padding-bottom: 30px;
}

/* padding 32px */
.p16 {
  padding: 32px;
}

.pl16 {
  padding-left: 32px;
}

.pr16 {
  padding-right: 32px;
}

.pt16 {
  padding-top: 32px;
}

.pb16 {
  padding-bottom: 32px;
}

.px16 {
  padding-left: 32px;
  padding-right: 32px;
}

.py16 {
  padding-top: 32px;
  padding-bottom: 32px;
}

/* padding 34px */
.p17 {
  padding: 34px;
}

.pl17 {
  padding-left: 34px;
}

.pr17 {
  padding-right: 34px;
}

.pt17 {
  padding-top: 34px;
}

.pb17 {
  padding-bottom: 34px;
}

.px17 {
  padding-left: 34px;
  padding-right: 34px;
}

.py17 {
  padding-top: 34px;
  padding-bottom: 34px;
}

/* padding 36px */
.p18 {
  padding: 36px;
}

.pl18 {
  padding-left: 36px;
}

.pr18 {
  padding-right: 36px;
}

.pt18 {
  padding-top: 36px;
}

.pb18 {
  padding-bottom: 36px;
}

.px18 {
  padding-left: 36px;
  padding-right: 36px;
}

.py18 {
  padding-top: 36px;
  padding-bottom: 36px;
}

/* padding 38px */
.p19 {
  padding: 38px;
}

.pl19 {
  padding-left: 38px;
}

.pr19 {
  padding-right: 38px;
}

.pt19 {
  padding-top: 38px;
}

.pb19 {
  padding-bottom: 38px;
}

.px19 {
  padding-left: 38px;
  padding-right: 38px;
}

.py19 {
  padding-top: 38px;
  padding-bottom: 38px;
}

/* padding 40px */
.p20 {
  padding: 40px;
}

.pl20 {
  padding-left: 40px;
}

.pr20 {
  padding-right: 40px;
}

.pt20 {
  padding-top: 40px;
}

.pb20 {
  padding-bottom: 40px;
}

.px20 {
  padding-left: 40px;
  padding-right: 40px;
}

.py20 {
  padding-top: 40px;
  padding-bottom: 40px;
}

/* padding 42px */
.p21 {
  padding: 42px;
}

.pl21 {
  padding-left: 42px;
}

.pr21 {
  padding-right: 42px;
}

.pt21 {
  padding-top: 42px;
}

.pb21 {
  padding-bottom: 42px;
}

.px21 {
  padding-left: 42px;
  padding-right: 42px;
}

.py21 {
  padding-top: 42px;
  padding-bottom: 42px;
}

/* padding 44px */
.p22 {
  padding: 44px;
}

.pl22 {
  padding-left: 44px;
}

.pr22 {
  padding-right: 44px;
}

.pt22 {
  padding-top: 44px;
}

.pb22 {
  padding-bottom: 44px;
}

.px22 {
  padding-left: 44px;
  padding-right: 44px;
}

.py22 {
  padding-top: 44px;
  padding-bottom: 44px;
}

/* padding 46px */
.p23 {
  padding: 46px;
}

.pl23 {
  padding-left: 46px;
}

.pr23 {
  padding-right: 46px;
}

.pt23 {
  padding-top: 46px;
}

.pb23 {
  padding-bottom: 46px;
}

.px23 {
  padding-left: 46px;
  padding-right: 46px;
}

.py23 {
  padding-top: 46px;
  padding-bottom: 46px;
}

/* padding 48px */
.p24 {
  padding: 48px;
}

.pl24 {
  padding-left: 48px;
}

.pr24 {
  padding-right: 48px;
}

.pt24 {
  padding-top: 48px;
}

.pb24 {
  padding-bottom: 48px;
}

.px24 {
  padding-left: 48px;
  padding-right: 48px;
}

.py24 {
  padding-top: 48px;
  padding-bottom: 48px;
}

/* padding 50px */
.p25 {
  padding: 50px;
}

.pl25 {
  padding-left: 50px;
}

.pr25 {
  padding-right: 50px;
}

.pt25 {
  padding-top: 50px;
}

.pb25 {
  padding-bottom: 50px;
}

.px25 {
  padding-left: 50px;
  padding-right: 50px;
}

.py25 {
  padding-top: 50px;
  padding-bottom: 50px;
}

/* padding 52px */
.p26 {
  padding: 52px;
}

.pl26 {
  padding-left: 52px;
}

.pr26 {
  padding-right: 52px;
}

.pt26 {
  padding-top: 52px;
}

.pb26 {
  padding-bottom: 52px;
}

.px26 {
  padding-left: 52px;
  padding-right: 52px;
}

.py26 {
  padding-top: 52px;
  padding-bottom: 52px;
}

/* padding 54px */
.p27 {
  padding: 54px;
}

.pl27 {
  padding-left: 54px;
}

.pr27 {
  padding-right: 54px;
}

.pt27 {
  padding-top: 54px;
}

.pb27 {
  padding-bottom: 54px;
}

.px27 {
  padding-left: 54px;
  padding-right: 54px;
}

.py27 {
  padding-top: 54px;
  padding-bottom: 54px;
}

/* padding 56px */
.p28 {
  padding: 56px;
}

.pl28 {
  padding-left: 56px;
}

.pr28 {
  padding-right: 56px;
}

.pt28 {
  padding-top: 56px;
}

.pb28 {
  padding-bottom: 56px;
}

.px28 {
  padding-left: 56px;
  padding-right: 56px;
}

.py28 {
  padding-top: 56px;
  padding-bottom: 56px;
}

/* padding 58px */
.p29 {
  padding: 58px;
}

.pl29 {
  padding-left: 58px;
}

.pr29 {
  padding-right: 58px;
}

.pt29 {
  padding-top: 58px;
}

.pb29 {
  padding-bottom: 58px;
}

.px29 {
  padding-left: 58px;
  padding-right: 58px;
}

.py29 {
  padding-top: 58px;
  padding-bottom: 58px;
}

/* padding 60px */
.p30 {
  padding: 60px;
}

.pl30 {
  padding-left: 60px;
}

.pr30 {
  padding-right: 60px;
}

.pt30 {
  padding-top: 60px;
}

.pb30 {
  padding-bottom: 60px;
}

.px30 {
  padding-left: 60px;
  padding-right: 60px;
}

.py30 {
  padding-top: 60px;
  padding-bottom: 60px;
}

/* font size*/
.fs1 {
  font-size: 2px;
}

.fs2 {
  font-size: 4px;
}

.fs3 {
  font-size: 6px;
}

.fs4 {
  font-size: 8px;
}

.fs5 {
  font-size: 10px;
}

.fs6 {
  font-size: 12px;
}

.fs7 {
  font-size: 14px;
}

.fs8 {
  font-size: 16px;
}

.fs9 {
  font-size: 18px;
}

.fs10 {
  font-size: 20px;
}

.fs11 {
  font-size: 22px;
}

.fs12 {
  font-size: 24px;
}

.fs13 {
  font-size: 26px;
}

.fs14 {
  font-size: 28px;
}

.fs15 {
  font-size: 30px;
}

.fs16 {
  font-size: 32px;
}

.fs17 {
  font-size: 34px;
}

.fs18 {
  font-size: 36px;
}

.fs19 {
  font-size: 38px;
}

.fs20 {
  font-size: 40px;
}

p {
  margin-bottom: 0px;
}

.text-bold-28 {
  font-weight: 700;
  font-size: 28px;
  line-height: 1.2;
}

.text-semibold-28 {
  font-weight: 600;
  font-size: 28px;
}

.text-regular-15 {
  font-weight: 400;
  font-size: 15px;
  line-height: 1.4;
}

.text-bold-15 {
  font-weight: 700;
  font-size: 15px;
  line-height: 1.4;
}

.text-semibold-15 {
  font-weight: 600;
  font-size: 15px;
  line-height: 1.4;
}

.text-regular-16 {
  font-weight: 400;
  font-size: 16px;
  line-height: 1.4;
}

.text-bold-16 {
  font-weight: 700;
  font-size: 16px;
  line-height: 1.4;
}

.text-semibold-16 {
  font-weight: 600;
  font-size: 16px;
  line-height: 1.4;
}

.text-semibold-18 {
  font-weight: 600;
  font-size: 18px;
  line-height: 1.4;
}

.text-bold-18 {
  font-weight: 700;
  font-size: 18px;
  line-height: 1.4;
}

.text-bold-20 {
  font-weight: 700;
  font-size: 20px;
  line-height: 1.4;
}

.text-bold-24 {
  font-weight: 700;
  font-size: 24px;
  line-height: 1.4;
}

.text-regular-14 {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
}

.text-bold-14 {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.4;
}

.text-regular-12 {
  font-weight: 400;
  font-size: 12px;
  line-height: 1.4;
}

.min-h100vh {
  min-height: 100vh;
}

/* color*/
.text-white {
  color: var(--white);
}

.text-indigo-50 {
  color: var(--indigo-50);
}

.text-indigo-25 {
  color: var(--indigo-25);
}

.text-indigo-900 {
  color: var(--indigo-900);
}

.text-indigo-800 {
  color: var(--indigo-800);
}

.text-indigo-200 {
  color: var(--indigo-200);
}

.text-indigo-400 {
  color: var(--indigo-400);
}

.text-indigo-600 {
  color: var(--indigo-600);
}

.text-cool-grey-800 {
  color: var(--cool-grey-800);
}

.text-cool-grey-200 {
  color: var(--cool-grey-200);
}

.text-cool-grey-500 {
  color: var(--cool-grey-500);
}

.text-cool-grey-100 {
  color: var(--cool-grey-100);
}

.text-cool-grey-600 {
  color: var(--cool-grey-600);
}

.text-cool-grey-400 {
  color: var(--cool-grey-400);
}

.text-purpel-graident {
  color: var(--purpel-graident);
}

.text-red-10 {
  color: var(--red-10);
}

.text-red-400 {
  color: var(--red-400);
}

.text-green-10 {
  color: var(--green-10);
}

.text-yellow-10 {
  color: var(--yellow-10);
}

.bg-gradient-primary {
  background: var(--purpel-graident);
}

.bg-white-10 {
  background-color: var(--white-10);
}

.bg-red-400 {
  background-color: var(--red-400);
}

.bg-green-400 {
  background-color: var(--green-400);
}

.bg-indigo-400 {
  background-color: var(--indigo-400);
}

.bg-yellow-10 {
  background-color: var(--yellow-10);
}

.bg-indigo-900 {
  background-color: var(--indigo-900);
}

.bg-cool-grey-400 {
  background-color: var(--cool-grey-400);
}

.bg-yellow-300 {
  background-color: var(--yellow-300);
}

/* shadow*/
.shadow1 {
  box-shadow: -2px 20px 50px -10px rgba(88, 92, 98, 0.12);
}

.shadow2 {
  box-shadow: 0px 5px 10px 0px rgba(99, 95, 133, 0.32);
}

.shadow3 {
  box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.shadow4 {
  box-shadow: 1px 1px 14px 0px rgba(0, 0, 0, 0.15);
}

.shadow5 {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.1);
}

/* radius */
.rd-32 {
  border-radius: 32px;
}

.rd-14 {
  border-radius: 14px;
}

.card-wrap {
  background-color: var(--white);
}

.max-w280 {
  max-width: 280px;
}

.text-primary-link {
  color: var(--indigo-600);
  transition: 300ms ease-in-out;
}
.text-primary-link:hover {
  color: var(--indigo-800);
  transition: 300ms ease-in-out;
}

.icon-box {
  line-height: 1;
}

.min-h100v {
  min-height: 100vh;
}

.btn-icon {
  line-height: 1;
  font-size: 12px;
  height: 12px;
}

.icon-box-next {
  height: 18px;
  font-size: 18px;
}

.max-w240 {
  max-width: 240px;
  width: 100%;
}

.card-structure {
  padding: 16px;
  background-color: var(--white);
  border-radius: 16px;
  box-shadow: none;
  border: none;
  min-height: 100%;
}
.card-structure .current-incentive-box {
  width: 100%;
}

.card-spacing-24 {
  padding: 24px;
}

.card-incentive-outer {
  display: flex;
  flex-wrap: wrap;
}

.w-90 {
  width: 90px;
}

.max-w440 {
  max-width: 440px;
  width: 100%;
}

.min-h100 {
  min-height: 100%;
}

.h-600 {
  height: 600px;
}

.h-border-top {
  border-color: var(--cool-grey-200);
  opacity: 1;
}

.max-h470 {
  max-height: 470px;
  overflow-y: auto;
}

.max-h556 {
  max-height: 556px;
  overflow-y: auto;
}

.layout-inner-wrap {
  padding: 16px 32px 16px 32px;
  position: sticky;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 9;
  background-color: var(--white-10);
}
.layout-inner-wrap .left-box {
  flex: 1 1;
}

.max-w350 {
  max-width: 350px;
  width: 100%;
}

.custom-dropdown .dropdown-toggle {
  background-color: transparent;
  border-radius: 0px;
  box-shadow: none;
}
.custom-dropdown .dropdown-toggle:after {
  display: none;
}

.notification-custom .dropdown-toggle {
  color: var(--indigo-600);
  font-size: 24px;
  padding: 0px;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  transition: 300ms ease-in-out;
}
.notification-custom .dropdown-toggle i {
  line-height: 1;
}
.notification-custom .dropdown-toggle:active {
  background-color: transparent !important;
  color: var(--indigo-800);
}
.notification-custom .dropdown-toggle:hover {
  color: var(--indigo-800);
}
.notification-custom .dropdown-toggle:focus-visible {
  box-shadow: none;
  outline: none;
}

/* notification */
.notification-custom .dropdown-menu {
  border: none;
  border-radius: 16px;
  box-shadow: -2px 20px 50px -10px rgba(88, 92, 98, 0.12);
  padding: 0px;
  min-width: 395px;
  margin-top: 8px;
}
.notification-custom .dropdown-menu:after {
  content: "";
  position: absolute;
  top: -10px;
  right: 20px;
  background-color: var(--white);
  width: 20px;
  height: 20px;
  transform: rotate(45deg);
  border-radius: 4px;
}
.notification-custom .notification-header {
  padding: 24px 24px 16px 24px;
}
.notification-custom .message-header {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--cool-grey-800);
  padding-bottom: 10px;
}
.notification-custom .message-header span {
  line-height: 1;
}
.notification-custom .message-header strong {
  font-weight: 700;
}
.notification-custom .message-detail {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
  color: var(--cool-grey-700);
}
.notification-custom .unread-meassage {
  background-color: var(--blue-gray-50);
}
.notification-custom .notification-footer {
  padding-top: 10px;
}

.notification-body-inner {
  padding: 16px;
}
.notification-body-inner .icon-left,
.notification-body-inner .right-icon {
  flex: 0 0 40px;
  max-width: 40px;
}
.notification-body-inner .center-message {
  flex: 1 1;
}

.meesage-time {
  text-align: center;
  margin-top: 8px;
  margin-bottom: 8px;
}

.message-date {
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--cool-grey-500);
  background-color: var(--cool-grey-200);
  border-radius: 30px;
  padding: 4px 10px;
}

.meesage-time {
  position: relative;
}
.meesage-time:after {
  content: "";
  position: absolute;
  top: 12px;
  left: 0px;
  right: 0px;
  width: calc(100% - 32px);
  margin: 0 auto;
  height: 1px;
  background-color: var(--cool-grey-200);
}
.meesage-time .message-outer-line {
  background-color: var(--white);
  padding: 0 10px;
  display: inline-block;
  position: relative;
  z-index: 1;
}

.notification-body-inner .cstm-icon-btn {
  transition: 300ms ease-in-out;
  opacity: 0;
  visibility: hidden;
}
.notification-body-inner:hover .cstm-icon-btn {
  opacity: 1;
  visibility: visible;
}

.notification-scroll {
  overflow-y: auto;
  height: 58vh;
}

.notification-empty {
  padding: 0 16px 0 16px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media only screen and (max-width: 1199px) {
  .layout-inner-wrap {
    padding-left: 15px;
    padding-right: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/_variable.scss","webpack://./src/style/_mixin.scss","webpack://./src/style/header.scss","webpack://./src/style/_custom.scss"],"names":[],"mappings":"AAAA,cAAA;AAWA,eAAA;AAYA,cAAA;AAQA,UAAA;AClBA,UAAA;AAQQ,eAAA;AACA;EACI,WAHK;ACZjB;;ADiBQ;EACI,gBANK;ACRjB;;ADgBQ;EACI,iBATK;ACJjB;;ADeQ;EACI,eAZK;ACAjB;;ADcQ;EACI,kBAfK;ACIjB;;ADaQ;EACI,gBAlBK;EAmBL,iBAnBK;ACSjB;;ADYQ;EACI,eAtBK;EAuBL,kBAvBK;ACcjB;;ADbQ,eAAA;AACA;EACI,WAHK;ACmBjB;;ADdQ;EACI,gBANK;ACuBjB;;ADfQ;EACI,iBATK;AC2BjB;;ADhBQ;EACI,eAZK;AC+BjB;;ADjBQ;EACI,kBAfK;ACmCjB;;ADlBQ;EACI,gBAlBK;EAmBL,iBAnBK;ACwCjB;;ADnBQ;EACI,eAtBK;EAuBL,kBAvBK;AC6CjB;;AD5CQ,eAAA;AACA;EACI,WAHK;ACkDjB;;AD7CQ;EACI,gBANK;ACsDjB;;AD9CQ;EACI,iBATK;AC0DjB;;AD/CQ;EACI,eAZK;AC8DjB;;ADhDQ;EACI,kBAfK;ACkEjB;;ADjDQ;EACI,gBAlBK;EAmBL,iBAnBK;ACuEjB;;ADlDQ;EACI,eAtBK;EAuBL,kBAvBK;AC4EjB;;AD3EQ,eAAA;AACA;EACI,WAHK;ACiFjB;;AD5EQ;EACI,gBANK;ACqFjB;;AD7EQ;EACI,iBATK;ACyFjB;;AD9EQ;EACI,eAZK;AC6FjB;;AD/EQ;EACI,kBAfK;ACiGjB;;ADhFQ;EACI,gBAlBK;EAmBL,iBAnBK;ACsGjB;;ADjFQ;EACI,eAtBK;EAuBL,kBAvBK;AC2GjB;;AD1GQ,gBAAA;AACA;EACI,YAHK;ACgHjB;;AD3GQ;EACI,iBANK;ACoHjB;;AD5GQ;EACI,kBATK;ACwHjB;;AD7GQ;EACI,gBAZK;AC4HjB;;AD9GQ;EACI,mBAfK;ACgIjB;;AD/GQ;EACI,iBAlBK;EAmBL,kBAnBK;ACqIjB;;ADhHQ;EACI,gBAtBK;EAuBL,mBAvBK;AC0IjB;;ADzIQ,gBAAA;AACA;EACI,YAHK;AC+IjB;;AD1IQ;EACI,iBANK;ACmJjB;;AD3IQ;EACI,kBATK;ACuJjB;;AD5IQ;EACI,gBAZK;AC2JjB;;AD7IQ;EACI,mBAfK;AC+JjB;;AD9IQ;EACI,iBAlBK;EAmBL,kBAnBK;ACoKjB;;AD/IQ;EACI,gBAtBK;EAuBL,mBAvBK;ACyKjB;;ADxKQ,gBAAA;AACA;EACI,YAHK;AC8KjB;;ADzKQ;EACI,iBANK;ACkLjB;;AD1KQ;EACI,kBATK;ACsLjB;;AD3KQ;EACI,gBAZK;AC0LjB;;AD5KQ;EACI,mBAfK;AC8LjB;;AD7KQ;EACI,iBAlBK;EAmBL,kBAnBK;ACmMjB;;AD9KQ;EACI,gBAtBK;EAuBL,mBAvBK;ACwMjB;;ADvMQ,gBAAA;AACA;EACI,YAHK;AC6MjB;;ADxMQ;EACI,iBANK;ACiNjB;;ADzMQ;EACI,kBATK;ACqNjB;;AD1MQ;EACI,gBAZK;ACyNjB;;AD3MQ;EACI,mBAfK;AC6NjB;;AD5MQ;EACI,iBAlBK;EAmBL,kBAnBK;ACkOjB;;AD7MQ;EACI,gBAtBK;EAuBL,mBAvBK;ACuOjB;;ADtOQ,gBAAA;AACA;EACI,YAHK;AC4OjB;;ADvOQ;EACI,iBANK;ACgPjB;;ADxOQ;EACI,kBATK;ACoPjB;;ADzOQ;EACI,gBAZK;ACwPjB;;AD1OQ;EACI,mBAfK;AC4PjB;;AD3OQ;EACI,iBAlBK;EAmBL,kBAnBK;ACiQjB;;AD5OQ;EACI,gBAtBK;EAuBL,mBAvBK;ACsQjB;;ADrQQ,gBAAA;AACA;EACI,YAHK;AC2QjB;;ADtQQ;EACI,iBANK;AC+QjB;;ADvQQ;EACI,kBATK;ACmRjB;;ADxQQ;EACI,gBAZK;ACuRjB;;ADzQQ;EACI,mBAfK;AC2RjB;;AD1QQ;EACI,iBAlBK;EAmBL,kBAnBK;ACgSjB;;AD3QQ;EACI,gBAtBK;EAuBL,mBAvBK;ACqSjB;;ADpSQ,gBAAA;AACA;EACI,YAHK;AC0SjB;;ADrSQ;EACI,iBANK;AC8SjB;;ADtSQ;EACI,kBATK;ACkTjB;;ADvSQ;EACI,gBAZK;ACsTjB;;ADxSQ;EACI,mBAfK;AC0TjB;;ADzSQ;EACI,iBAlBK;EAmBL,kBAnBK;AC+TjB;;AD1SQ;EACI,gBAtBK;EAuBL,mBAvBK;ACoUjB;;ADnUQ,gBAAA;AACA;EACI,YAHK;ACyUjB;;ADpUQ;EACI,iBANK;AC6UjB;;ADrUQ;EACI,kBATK;ACiVjB;;ADtUQ;EACI,gBAZK;ACqVjB;;ADvUQ;EACI,mBAfK;ACyVjB;;ADxUQ;EACI,iBAlBK;EAmBL,kBAnBK;AC8VjB;;ADzUQ;EACI,gBAtBK;EAuBL,mBAvBK;ACmWjB;;ADlWQ,gBAAA;AACA;EACI,YAHK;ACwWjB;;ADnWQ;EACI,iBANK;AC4WjB;;ADpWQ;EACI,kBATK;ACgXjB;;ADrWQ;EACI,gBAZK;ACoXjB;;ADtWQ;EACI,mBAfK;ACwXjB;;ADvWQ;EACI,iBAlBK;EAmBL,kBAnBK;AC6XjB;;ADxWQ;EACI,gBAtBK;EAuBL,mBAvBK;ACkYjB;;ADjYQ,gBAAA;AACA;EACI,YAHK;ACuYjB;;ADlYQ;EACI,iBANK;AC2YjB;;ADnYQ;EACI,kBATK;AC+YjB;;ADpYQ;EACI,gBAZK;ACmZjB;;ADrYQ;EACI,mBAfK;ACuZjB;;ADtYQ;EACI,iBAlBK;EAmBL,kBAnBK;AC4ZjB;;ADvYQ;EACI,gBAtBK;EAuBL,mBAvBK;ACiajB;;ADhaQ,gBAAA;AACA;EACI,YAHK;ACsajB;;ADjaQ;EACI,iBANK;AC0ajB;;ADlaQ;EACI,kBATK;AC8ajB;;ADnaQ;EACI,gBAZK;ACkbjB;;ADpaQ;EACI,mBAfK;ACsbjB;;ADraQ;EACI,iBAlBK;EAmBL,kBAnBK;AC2bjB;;ADtaQ;EACI,gBAtBK;EAuBL,mBAvBK;ACgcjB;;AD/bQ,gBAAA;AACA;EACI,YAHK;ACqcjB;;ADhcQ;EACI,iBANK;ACycjB;;ADjcQ;EACI,kBATK;AC6cjB;;ADlcQ;EACI,gBAZK;ACidjB;;ADncQ;EACI,mBAfK;ACqdjB;;ADpcQ;EACI,iBAlBK;EAmBL,kBAnBK;AC0djB;;ADrcQ;EACI,gBAtBK;EAuBL,mBAvBK;AC+djB;;AD9dQ,gBAAA;AACA;EACI,YAHK;ACoejB;;AD/dQ;EACI,iBANK;ACwejB;;ADheQ;EACI,kBATK;AC4ejB;;ADjeQ;EACI,gBAZK;ACgfjB;;ADleQ;EACI,mBAfK;ACofjB;;ADneQ;EACI,iBAlBK;EAmBL,kBAnBK;ACyfjB;;ADpeQ;EACI,gBAtBK;EAuBL,mBAvBK;AC8fjB;;AD7fQ,gBAAA;AACA;EACI,YAHK;ACmgBjB;;AD9fQ;EACI,iBANK;ACugBjB;;AD/fQ;EACI,kBATK;AC2gBjB;;ADhgBQ;EACI,gBAZK;AC+gBjB;;ADjgBQ;EACI,mBAfK;ACmhBjB;;ADlgBQ;EACI,iBAlBK;EAmBL,kBAnBK;ACwhBjB;;ADngBQ;EACI,gBAtBK;EAuBL,mBAvBK;AC6hBjB;;AD5hBQ,gBAAA;AACA;EACI,YAHK;ACkiBjB;;AD7hBQ;EACI,iBANK;ACsiBjB;;AD9hBQ;EACI,kBATK;AC0iBjB;;AD/hBQ;EACI,gBAZK;AC8iBjB;;ADhiBQ;EACI,mBAfK;ACkjBjB;;ADjiBQ;EACI,iBAlBK;EAmBL,kBAnBK;ACujBjB;;ADliBQ;EACI,gBAtBK;EAuBL,mBAvBK;AC4jBjB;;AD3jBQ,gBAAA;AACA;EACI,YAHK;ACikBjB;;AD5jBQ;EACI,iBANK;ACqkBjB;;AD7jBQ;EACI,kBATK;ACykBjB;;AD9jBQ;EACI,gBAZK;AC6kBjB;;AD/jBQ;EACI,mBAfK;ACilBjB;;ADhkBQ;EACI,iBAlBK;EAmBL,kBAnBK;ACslBjB;;ADjkBQ;EACI,gBAtBK;EAuBL,mBAvBK;AC2lBjB;;AD1lBQ,gBAAA;AACA;EACI,YAHK;ACgmBjB;;AD3lBQ;EACI,iBANK;AComBjB;;AD5lBQ;EACI,kBATK;ACwmBjB;;AD7lBQ;EACI,gBAZK;AC4mBjB;;AD9lBQ;EACI,mBAfK;ACgnBjB;;AD/lBQ;EACI,iBAlBK;EAmBL,kBAnBK;ACqnBjB;;ADhmBQ;EACI,gBAtBK;EAuBL,mBAvBK;AC0nBjB;;ADznBQ,gBAAA;AACA;EACI,YAHK;AC+nBjB;;AD1nBQ;EACI,iBANK;ACmoBjB;;AD3nBQ;EACI,kBATK;ACuoBjB;;AD5nBQ;EACI,gBAZK;AC2oBjB;;AD7nBQ;EACI,mBAfK;AC+oBjB;;AD9nBQ;EACI,iBAlBK;EAmBL,kBAnBK;ACopBjB;;AD/nBQ;EACI,gBAtBK;EAuBL,mBAvBK;ACypBjB;;ADxpBQ,gBAAA;AACA;EACI,YAHK;AC8pBjB;;ADzpBQ;EACI,iBANK;ACkqBjB;;AD1pBQ;EACI,kBATK;ACsqBjB;;AD3pBQ;EACI,gBAZK;AC0qBjB;;AD5pBQ;EACI,mBAfK;AC8qBjB;;AD7pBQ;EACI,iBAlBK;EAmBL,kBAnBK;ACmrBjB;;AD9pBQ;EACI,gBAtBK;EAuBL,mBAvBK;ACwrBjB;;ADvrBQ,gBAAA;AACA;EACI,YAHK;AC6rBjB;;ADxrBQ;EACI,iBANK;ACisBjB;;ADzrBQ;EACI,kBATK;ACqsBjB;;AD1rBQ;EACI,gBAZK;ACysBjB;;AD3rBQ;EACI,mBAfK;AC6sBjB;;AD5rBQ;EACI,iBAlBK;EAmBL,kBAnBK;ACktBjB;;AD7rBQ;EACI,gBAtBK;EAuBL,mBAvBK;ACutBjB;;ADttBQ,gBAAA;AACA;EACI,YAHK;AC4tBjB;;ADvtBQ;EACI,iBANK;ACguBjB;;ADxtBQ;EACI,kBATK;ACouBjB;;ADztBQ;EACI,gBAZK;ACwuBjB;;AD1tBQ;EACI,mBAfK;AC4uBjB;;AD3tBQ;EACI,iBAlBK;EAmBL,kBAnBK;ACivBjB;;AD5tBQ;EACI,gBAtBK;EAuBL,mBAvBK;ACsvBjB;;ADrvBQ,gBAAA;AACA;EACI,YAHK;AC2vBjB;;ADtvBQ;EACI,iBANK;AC+vBjB;;ADvvBQ;EACI,kBATK;ACmwBjB;;ADxvBQ;EACI,gBAZK;ACuwBjB;;ADzvBQ;EACI,mBAfK;AC2wBjB;;AD1vBQ;EACI,iBAlBK;EAmBL,kBAnBK;ACgxBjB;;AD3vBQ;EACI,gBAtBK;EAuBL,mBAvBK;ACqxBjB;;ADpxBQ,gBAAA;AACA;EACI,YAHK;AC0xBjB;;ADrxBQ;EACI,iBANK;AC8xBjB;;ADtxBQ;EACI,kBATK;ACkyBjB;;ADvxBQ;EACI,gBAZK;ACsyBjB;;ADxxBQ;EACI,mBAfK;AC0yBjB;;ADzxBQ;EACI,iBAlBK;EAmBL,kBAnBK;AC+yBjB;;AD1xBQ;EACI,gBAtBK;EAuBL,mBAvBK;ACozBjB;;ADnzBQ,gBAAA;AACA;EACI,YAHK;ACyzBjB;;ADpzBQ;EACI,iBANK;AC6zBjB;;ADrzBQ;EACI,kBATK;ACi0BjB;;ADtzBQ;EACI,gBAZK;ACq0BjB;;ADvzBQ;EACI,mBAfK;ACy0BjB;;ADxzBQ;EACI,iBAlBK;EAmBL,kBAnBK;AC80BjB;;ADzzBQ;EACI,gBAtBK;EAuBL,mBAvBK;ACm1BjB;;ADl1BQ,gBAAA;AACA;EACI,YAHK;ACw1BjB;;ADn1BQ;EACI,iBANK;AC41BjB;;ADp1BQ;EACI,kBATK;ACg2BjB;;ADr1BQ;EACI,gBAZK;ACo2BjB;;ADt1BQ;EACI,mBAfK;ACw2BjB;;ADv1BQ;EACI,iBAlBK;EAmBL,kBAnBK;AC62BjB;;ADx1BQ;EACI,gBAtBK;EAuBL,mBAvBK;ACk3BjB;;ADj3BQ,gBAAA;AACA;EACI,YAHK;ACu3BjB;;ADl3BQ;EACI,iBANK;AC23BjB;;ADn3BQ;EACI,kBATK;AC+3BjB;;ADp3BQ;EACI,gBAZK;ACm4BjB;;ADr3BQ;EACI,mBAfK;ACu4BjB;;ADt3BQ;EACI,iBAlBK;EAmBL,kBAnBK;AC44BjB;;ADv3BQ;EACI,gBAtBK;EAuBL,mBAvBK;ACi5BjB;;ADj3BQ,gBAAA;AACA;EACI,YAHM;ACu3BlB;;ADl3BQ;EACI,iBANM;AC23BlB;;ADn3BQ;EACI,kBATM;AC+3BlB;;ADp3BQ;EACI,gBAZM;ACm4BlB;;ADr3BQ;EACI,mBAfM;ACu4BlB;;ADt3BQ;EACI,iBAlBM;EAmBN,kBAnBM;AC44BlB;;ADv3BQ;EACI,gBAtBM;EAuBN,mBAvBM;ACi5BlB;;ADh5BQ,gBAAA;AACA;EACI,YAHM;ACs5BlB;;ADj5BQ;EACI,iBANM;AC05BlB;;ADl5BQ;EACI,kBATM;AC85BlB;;ADn5BQ;EACI,gBAZM;ACk6BlB;;ADp5BQ;EACI,mBAfM;ACs6BlB;;ADr5BQ;EACI,iBAlBM;EAmBN,kBAnBM;AC26BlB;;ADt5BQ;EACI,gBAtBM;EAuBN,mBAvBM;ACg7BlB;;AD/6BQ,gBAAA;AACA;EACI,YAHM;ACq7BlB;;ADh7BQ;EACI,iBANM;ACy7BlB;;ADj7BQ;EACI,kBATM;AC67BlB;;ADl7BQ;EACI,gBAZM;ACi8BlB;;ADn7BQ;EACI,mBAfM;ACq8BlB;;ADp7BQ;EACI,iBAlBM;EAmBN,kBAnBM;AC08BlB;;ADr7BQ;EACI,gBAtBM;EAuBN,mBAvBM;AC+8BlB;;AD98BQ,gBAAA;AACA;EACI,YAHM;ACo9BlB;;AD/8BQ;EACI,iBANM;ACw9BlB;;ADh9BQ;EACI,kBATM;AC49BlB;;ADj9BQ;EACI,gBAZM;ACg+BlB;;ADl9BQ;EACI,mBAfM;ACo+BlB;;ADn9BQ;EACI,iBAlBM;EAmBN,kBAnBM;ACy+BlB;;ADp9BQ;EACI,gBAtBM;EAuBN,mBAvBM;AC8+BlB;;AD7+BQ,iBAAA;AACA;EACI,aAHM;ACm/BlB;;AD9+BQ;EACI,kBANM;ACu/BlB;;AD/+BQ;EACI,mBATM;AC2/BlB;;ADh/BQ;EACI,iBAZM;AC+/BlB;;ADj/BQ;EACI,oBAfM;ACmgClB;;ADl/BQ;EACI,kBAlBM;EAmBN,mBAnBM;ACwgClB;;ADn/BQ;EACI,iBAtBM;EAuBN,oBAvBM;AC6gClB;;AD5gCQ,iBAAA;AACA;EACI,aAHM;ACkhClB;;AD7gCQ;EACI,kBANM;ACshClB;;AD9gCQ;EACI,mBATM;AC0hClB;;AD/gCQ;EACI,iBAZM;AC8hClB;;ADhhCQ;EACI,oBAfM;ACkiClB;;ADjhCQ;EACI,kBAlBM;EAmBN,mBAnBM;ACuiClB;;ADlhCQ;EACI,iBAtBM;EAuBN,oBAvBM;AC4iClB;;AD3iCQ,iBAAA;AACA;EACI,aAHM;ACijClB;;AD5iCQ;EACI,kBANM;ACqjClB;;AD7iCQ;EACI,mBATM;ACyjClB;;AD9iCQ;EACI,iBAZM;AC6jClB;;AD/iCQ;EACI,oBAfM;ACikClB;;ADhjCQ;EACI,kBAlBM;EAmBN,mBAnBM;ACskClB;;ADjjCQ;EACI,iBAtBM;EAuBN,oBAvBM;AC2kClB;;AD1kCQ,iBAAA;AACA;EACI,aAHM;ACglClB;;AD3kCQ;EACI,kBANM;AColClB;;AD5kCQ;EACI,mBATM;ACwlClB;;AD7kCQ;EACI,iBAZM;AC4lClB;;AD9kCQ;EACI,oBAfM;ACgmClB;;AD/kCQ;EACI,kBAlBM;EAmBN,mBAnBM;ACqmClB;;ADhlCQ;EACI,iBAtBM;EAuBN,oBAvBM;AC0mClB;;ADzmCQ,iBAAA;AACA;EACI,aAHM;AC+mClB;;AD1mCQ;EACI,kBANM;ACmnClB;;AD3mCQ;EACI,mBATM;ACunClB;;AD5mCQ;EACI,iBAZM;AC2nClB;;AD7mCQ;EACI,oBAfM;AC+nClB;;AD9mCQ;EACI,kBAlBM;EAmBN,mBAnBM;ACooClB;;AD/mCQ;EACI,iBAtBM;EAuBN,oBAvBM;ACyoClB;;ADxoCQ,iBAAA;AACA;EACI,aAHM;AC8oClB;;ADzoCQ;EACI,kBANM;ACkpClB;;AD1oCQ;EACI,mBATM;ACspClB;;AD3oCQ;EACI,iBAZM;AC0pClB;;AD5oCQ;EACI,oBAfM;AC8pClB;;AD7oCQ;EACI,kBAlBM;EAmBN,mBAnBM;ACmqClB;;AD9oCQ;EACI,iBAtBM;EAuBN,oBAvBM;ACwqClB;;ADvqCQ,iBAAA;AACA;EACI,aAHM;AC6qClB;;ADxqCQ;EACI,kBANM;ACirClB;;ADzqCQ;EACI,mBATM;ACqrClB;;AD1qCQ;EACI,iBAZM;ACyrClB;;AD3qCQ;EACI,oBAfM;AC6rClB;;AD5qCQ;EACI,kBAlBM;EAmBN,mBAnBM;ACksClB;;AD7qCQ;EACI,iBAtBM;EAuBN,oBAvBM;ACusClB;;ADtsCQ,iBAAA;AACA;EACI,aAHM;AC4sClB;;ADvsCQ;EACI,kBANM;ACgtClB;;ADxsCQ;EACI,mBATM;ACotClB;;ADzsCQ;EACI,iBAZM;ACwtClB;;AD1sCQ;EACI,oBAfM;AC4tClB;;AD3sCQ;EACI,kBAlBM;EAmBN,mBAnBM;ACiuClB;;AD5sCQ;EACI,iBAtBM;EAuBN,oBAvBM;ACsuClB;;ADruCQ,iBAAA;AACA;EACI,aAHM;AC2uClB;;ADtuCQ;EACI,kBANM;AC+uClB;;ADvuCQ;EACI,mBATM;ACmvClB;;ADxuCQ;EACI,iBAZM;ACuvClB;;ADzuCQ;EACI,oBAfM;AC2vClB;;AD1uCQ;EACI,kBAlBM;EAmBN,mBAnBM;ACgwClB;;AD3uCQ;EACI,iBAtBM;EAuBN,oBAvBM;ACqwClB;;ADpwCQ,iBAAA;AACA;EACI,aAHM;AC0wClB;;ADrwCQ;EACI,kBANM;AC8wClB;;ADtwCQ;EACI,mBATM;ACkxClB;;ADvwCQ;EACI,iBAZM;ACsxClB;;ADxwCQ;EACI,oBAfM;AC0xClB;;ADzwCQ;EACI,kBAlBM;EAmBN,mBAnBM;AC+xClB;;AD1wCQ;EACI,iBAtBM;EAuBN,oBAvBM;ACoyClB;;ADnyCQ,iBAAA;AACA;EACI,aAHM;ACyyClB;;ADpyCQ;EACI,kBANM;AC6yClB;;ADryCQ;EACI,mBATM;ACizClB;;ADtyCQ;EACI,iBAZM;ACqzClB;;ADvyCQ;EACI,oBAfM;ACyzClB;;ADxyCQ;EACI,kBAlBM;EAmBN,mBAnBM;AC8zClB;;ADzyCQ;EACI,iBAtBM;EAuBN,oBAvBM;ACm0ClB;;ADl0CQ,iBAAA;AACA;EACI,aAHM;ACw0ClB;;ADn0CQ;EACI,kBANM;AC40ClB;;ADp0CQ;EACI,mBATM;ACg1ClB;;ADr0CQ;EACI,iBAZM;ACo1ClB;;ADt0CQ;EACI,oBAfM;ACw1ClB;;ADv0CQ;EACI,kBAlBM;EAmBN,mBAnBM;AC61ClB;;ADx0CQ;EACI,iBAtBM;EAuBN,oBAvBM;ACk2ClB;;ADj2CQ,iBAAA;AACA;EACI,aAHM;ACu2ClB;;ADl2CQ;EACI,kBANM;AC22ClB;;ADn2CQ;EACI,mBATM;AC+2ClB;;ADp2CQ;EACI,iBAZM;ACm3ClB;;ADr2CQ;EACI,oBAfM;ACu3ClB;;ADt2CQ;EACI,kBAlBM;EAmBN,mBAnBM;AC43ClB;;ADv2CQ;EACI,iBAtBM;EAuBN,oBAvBM;ACi4ClB;;ADh4CQ,iBAAA;AACA;EACI,aAHM;ACs4ClB;;ADj4CQ;EACI,kBANM;AC04ClB;;ADl4CQ;EACI,mBATM;AC84ClB;;ADn4CQ;EACI,iBAZM;ACk5ClB;;ADp4CQ;EACI,oBAfM;ACs5ClB;;ADr4CQ;EACI,kBAlBM;EAmBN,mBAnBM;AC25ClB;;ADt4CQ;EACI,iBAtBM;EAuBN,oBAvBM;ACg6ClB;;AD/5CQ,iBAAA;AACA;EACI,aAHM;ACq6ClB;;ADh6CQ;EACI,kBANM;ACy6ClB;;ADj6CQ;EACI,mBATM;AC66ClB;;ADl6CQ;EACI,iBAZM;ACi7ClB;;ADn6CQ;EACI,oBAfM;ACq7ClB;;ADp6CQ;EACI,kBAlBM;EAmBN,mBAnBM;AC07ClB;;ADr6CQ;EACI,iBAtBM;EAuBN,oBAvBM;AC+7ClB;;AD97CQ,iBAAA;AACA;EACI,aAHM;ACo8ClB;;AD/7CQ;EACI,kBANM;ACw8ClB;;ADh8CQ;EACI,mBATM;AC48ClB;;ADj8CQ;EACI,iBAZM;ACg9ClB;;ADl8CQ;EACI,oBAfM;ACo9ClB;;ADn8CQ;EACI,kBAlBM;EAmBN,mBAnBM;ACy9ClB;;ADp8CQ;EACI,iBAtBM;EAuBN,oBAvBM;AC89ClB;;AD79CQ,iBAAA;AACA;EACI,aAHM;ACm+ClB;;AD99CQ;EACI,kBANM;ACu+ClB;;AD/9CQ;EACI,mBATM;AC2+ClB;;ADh+CQ;EACI,iBAZM;AC++ClB;;ADj+CQ;EACI,oBAfM;ACm/ClB;;ADl+CQ;EACI,kBAlBM;EAmBN,mBAnBM;ACw/ClB;;ADn+CQ;EACI,iBAtBM;EAuBN,oBAvBM;AC6/ClB;;AD5/CQ,iBAAA;AACA;EACI,aAHM;ACkgDlB;;AD7/CQ;EACI,kBANM;ACsgDlB;;AD9/CQ;EACI,mBATM;AC0gDlB;;AD//CQ;EACI,iBAZM;AC8gDlB;;ADhgDQ;EACI,oBAfM;ACkhDlB;;ADjgDQ;EACI,kBAlBM;EAmBN,mBAnBM;ACuhDlB;;ADlgDQ;EACI,iBAtBM;EAuBN,oBAvBM;AC4hDlB;;AD3hDQ,iBAAA;AACA;EACI,aAHM;ACiiDlB;;AD5hDQ;EACI,kBANM;ACqiDlB;;AD7hDQ;EACI,mBATM;ACyiDlB;;AD9hDQ;EACI,iBAZM;AC6iDlB;;AD/hDQ;EACI,oBAfM;ACijDlB;;ADhiDQ;EACI,kBAlBM;EAmBN,mBAnBM;ACsjDlB;;ADjiDQ;EACI,iBAtBM;EAuBN,oBAvBM;AC2jDlB;;AD1jDQ,iBAAA;AACA;EACI,aAHM;ACgkDlB;;AD3jDQ;EACI,kBANM;ACokDlB;;AD5jDQ;EACI,mBATM;ACwkDlB;;AD7jDQ;EACI,iBAZM;AC4kDlB;;AD9jDQ;EACI,oBAfM;ACglDlB;;AD/jDQ;EACI,kBAlBM;EAmBN,mBAnBM;ACqlDlB;;ADhkDQ;EACI,iBAtBM;EAuBN,oBAvBM;AC0lDlB;;ADzlDQ,iBAAA;AACA;EACI,aAHM;AC+lDlB;;AD1lDQ;EACI,kBANM;ACmmDlB;;AD3lDQ;EACI,mBATM;ACumDlB;;AD5lDQ;EACI,iBAZM;AC2mDlB;;AD7lDQ;EACI,oBAfM;AC+mDlB;;AD9lDQ;EACI,kBAlBM;EAmBN,mBAnBM;AConDlB;;AD/lDQ;EACI,iBAtBM;EAuBN,oBAvBM;ACynDlB;;ADxnDQ,iBAAA;AACA;EACI,aAHM;AC8nDlB;;ADznDQ;EACI,kBANM;ACkoDlB;;AD1nDQ;EACI,mBATM;ACsoDlB;;AD3nDQ;EACI,iBAZM;AC0oDlB;;AD5nDQ;EACI,oBAfM;AC8oDlB;;AD7nDQ;EACI,kBAlBM;EAmBN,mBAnBM;ACmpDlB;;AD9nDQ;EACI,iBAtBM;EAuBN,oBAvBM;ACwpDlB;;ADvpDQ,iBAAA;AACA;EACI,aAHM;AC6pDlB;;ADxpDQ;EACI,kBANM;ACiqDlB;;ADzpDQ;EACI,mBATM;ACqqDlB;;AD1pDQ;EACI,iBAZM;ACyqDlB;;AD3pDQ;EACI,oBAfM;AC6qDlB;;AD5pDQ;EACI,kBAlBM;EAmBN,mBAnBM;ACkrDlB;;AD7pDQ;EACI,iBAtBM;EAuBN,oBAvBM;ACurDlB;;ADtrDQ,iBAAA;AACA;EACI,aAHM;AC4rDlB;;ADvrDQ;EACI,kBANM;ACgsDlB;;ADxrDQ;EACI,mBATM;ACosDlB;;ADzrDQ;EACI,iBAZM;ACwsDlB;;AD1rDQ;EACI,oBAfM;AC4sDlB;;AD3rDQ;EACI,kBAlBM;EAmBN,mBAnBM;ACitDlB;;AD5rDQ;EACI,iBAtBM;EAuBN,oBAvBM;ACstDlB;;ADrtDQ,iBAAA;AACA;EACI,aAHM;AC2tDlB;;ADttDQ;EACI,kBANM;AC+tDlB;;ADvtDQ;EACI,mBATM;ACmuDlB;;ADxtDQ;EACI,iBAZM;ACuuDlB;;ADztDQ;EACI,oBAfM;AC2uDlB;;AD1tDQ;EACI,kBAlBM;EAmBN,mBAnBM;ACgvDlB;;AD3tDQ;EACI,iBAtBM;EAuBN,oBAvBM;ACqvDlB;;ADpvDQ,iBAAA;AACA;EACI,aAHM;AC0vDlB;;ADrvDQ;EACI,kBANM;AC8vDlB;;ADtvDQ;EACI,mBATM;ACkwDlB;;ADvvDQ;EACI,iBAZM;ACswDlB;;ADxvDQ;EACI,oBAfM;AC0wDlB;;ADzvDQ;EACI,kBAlBM;EAmBN,mBAnBM;AC+wDlB;;AD1vDQ;EACI,iBAtBM;EAuBN,oBAvBM;ACoxDlB;;ADvvDA,aAAA;AAKQ;EACI,cAFO;ACwvDnB;;ADvvDQ;EACI,cAFO;AC4vDnB;;AD3vDQ;EACI,cAFO;ACgwDnB;;AD/vDQ;EACI,cAFO;ACowDnB;;ADnwDQ;EACI,eAFO;ACwwDnB;;ADvwDQ;EACI,eAFO;AC4wDnB;;AD3wDQ;EACI,eAFO;ACgxDnB;;AD/wDQ;EACI,eAFO;ACoxDnB;;ADnxDQ;EACI,eAFO;ACwxDnB;;ADvxDQ;EACI,eAFO;AC4xDnB;;AD3xDQ;EACI,eAFO;ACgyDnB;;AD/xDQ;EACI,eAFO;ACoyDnB;;ADnyDQ;EACI,eAFO;ACwyDnB;;ADvyDQ;EACI,eAFO;AC4yDnB;;AD3yDQ;EACI,eAFO;ACgzDnB;;AD/yDQ;EACI,eAFO;ACozDnB;;ADnzDQ;EACI,eAFO;ACwzDnB;;ADvzDQ;EACI,eAFO;AC4zDnB;;AD3zDQ;EACI,eAFO;ACg0DnB;;AD/zDQ;EACI,eAFO;ACo0DnB;;ACx5DA;EACI,kBAAA;AD25DJ;;ACx5DA;EACI,gBHcK;EGbL,eHJI;EGKJ,gBAAA;AD25DJ;;ACz5DA;EACI,gBHQK;EGPL,eHTI;AEq6DR;;ACz5DA;EACI,gBHCK;EGAL,eHXI;EGYJ,gBAAA;AD45DJ;;AC15DA;EACI,gBHDK;EGEL,eHhBI;EGiBJ,gBAAA;AD65DJ;;AC35DA;EACI,gBHPK;EGQL,eHrBI;EGsBJ,gBAAA;AD85DJ;;AC35DA;EACI,gBHfK;EGgBL,eH1BI;EG2BJ,gBAAA;AD85DJ;;AC55DA;EACI,gBHjBK;EGkBL,eH/BI;EGgCJ,gBAAA;AD+5DJ;;AC75DA;EACI,gBHvBK;EGwBL,eHpCI;EGqCJ,gBAAA;ADg6DJ;;AC75DA;EACI,gBH7BK;EG8BL,eHzCI;EG0CJ,gBAAA;ADg6DJ;;AC95DA;EACI,gBHjCK;EGkCL,eH9CI;EG+CJ,gBAAA;ADi6DJ;;AC95DA;EACI,gBHvCK;EGwCL,eHxDI;EGyDJ,gBAAA;ADi6DJ;;AC/5DA;EACI,gBH5CK;EG6CL,eH5DI;EG6DJ,gBAAA;ADk6DJ;;AC/5DA;EACI,gBHrDK;EGsDL,eH9DI;EG+DJ,gBAAA;ADk6DJ;;ACh6DA;EACI,gBHvDK;EGwDL,eHnEI;EGoEJ,gBAAA;ADm6DJ;;ACh6DA;EACI,gBHhEK;EGiEL,eHxEI;EGyEJ,gBAAA;ADm6DJ;;ACh6DA;EACI,iBAAA;ADm6DJ;;ACj6DA,SAAA;AACA;EACI,mBAAA;ADo6DJ;;ACl6DA;EACI,uBAAA;ADq6DJ;;ACn6DA;EACI,uBAAA;ADs6DJ;;ACp6DA;EACI,wBAAA;ADu6DJ;;ACr6DA;EACI,wBAAA;ADw6DJ;;ACt6DA;EACI,wBAAA;ADy6DJ;;ACv6DA;EACI,wBAAA;AD06DJ;;ACv6DA;EACI,wBAAA;AD06DJ;;ACx6DA;EACI,2BAAA;AD26DJ;;ACz6DA;EACI,2BAAA;AD46DJ;;AC16DA;EACI,2BAAA;AD66DJ;;AC36DA;EACI,2BAAA;AD86DJ;;AC56DA;EACI,2BAAA;AD+6DJ;;AC76DA;EACI,2BAAA;ADg7DJ;;AC76DA;EACI,6BAAA;ADg7DJ;;AC96DA;EACI,oBAAA;ADi7DJ;;AC/6DA;EACI,qBAAA;ADk7DJ;;AC/6DA;EACI,sBAAA;ADk7DJ;;AC/6DA;EACI,uBAAA;ADk7DJ;;ACh7DA;EACI,kCAAA;ADm7DJ;;ACj7DA;EACI,iCAAA;ADo7DJ;;ACl7DA;EACI,gCAAA;ADq7DJ;;ACn7DA;EACI,kCAAA;ADs7DJ;;ACp7DA;EACI,mCAAA;ADu7DJ;;ACp7DA;EACI,kCAAA;ADu7DJ;;ACr7DA;EACI,mCAAA;ADw7DJ;;ACt7DA;EACI,sCAAA;ADy7DJ;;ACv7DA;EACI,mCAAA;AD07DJ;;ACv7DA,UAAA;AACA;EACI,uDH5JM;AEslEV;;ACx7DA;EACI,oDH9JM;AEylEV;;ACz7DA;EACI,mDHhKM;AE4lEV;;AC17DA;EACI,gDHlKM;AE+lEV;;AC37DA;EACI,qFHpKM;AEkmEV;;AC37DA,WAAA;AACA;EACI,mBAAA;AD87DJ;;AC57DA;EACI,mBAAA;AD+7DJ;;AC77DA;EACI,8BAAA;ADg8DJ;;AC97DA;EACI,gBAAA;ADi8DJ;;AC97DA;EACI,wBAAA;EF/MA,6BEgNA;ADo8DJ;ACn8DI;EACI,wBAAA;EFlNJ,6BEmNI;ADw8DR;;ACp8DA;EACI,cAAA;ADu8DJ;;ACp8DA;EACI,iBAAA;ADu8DJ;;ACp8DA;EACI,cAAA;EACA,eAAA;EACA,YAAA;ADu8DJ;;ACr8DA;EACI,YAAA;EACA,eAAA;ADw8DJ;;ACt8DA;EACI,gBAAA;EACA,WAAA;ADy8DJ;;ACv8DA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AD08DJ;ACz8DI;EACI,WAAA;AD28DR;;ACx8DA;EACI,aAAA;AD28DJ;;ACz8DA;EACI,aAAA;EACA,eAAA;AD48DJ;;ACz8DA;EACI,WAAA;AD48DJ;;AC18DA;EACI,gBAAA;EACA,WAAA;AD68DJ;;AC18DA;EACI,gBAAA;AD68DJ;;AC38DA;EACI,aAAA;AD88DJ;;AC58DA;EACI,kCAAA;EACA,UAAA;AD+8DJ;;AC58DA;EACI,iBAAA;EACA,gBAAA;AD+8DJ;;AC78DA;EACI,iBAAA;EACA,gBAAA;ADg9DJ;;AAxuEA;EACI,4BAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,iCAAA;AA2uEJ;AA1uEI;EACI,SAAA;AA4uER;;AAzuEA;EACI,gBAAA;EACA,WAAA;AA4uEJ;;AAzuEI;EACI,6BAAA;EACA,kBAAA;EACA,gBAAA;AA4uER;AA3uEQ;EACI,aAAA;AA6uEZ;;AAvuEI;EACI,wBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EDrCJ,6BCyCI;AA0uER;AA7uEQ;EACI,cAAA;AA+uEZ;AA5uEQ;EACI,wCAAA;EACA,wBAAA;AA8uEZ;AA5uEQ;EACI,wBAAA;AA8uEZ;AA5uEQ;EACI,gBAAA;EACA,aAAA;AA8uEZ;;AAzuEA,iBAAA;AAGI;EACI,YAAA;EACA,mBAAA;EACA,uDAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AA0uER;AAzuEQ;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;AA2uEZ;AAxuEI;EACI,4BAAA;AA0uER;AAxuEI;EACI,eF9EA;EE+EA,gBFvEC;EEwED,gBAAA;EACA,2BAAA;EACA,oBAAA;AA0uER;AAzuEQ;EACI,cAAA;AA2uEZ;AAzuEQ;EACI,gBF5EH;AEuzET;AAxuEI;EACI,eF1FA;EE2FA,gBFpFC;EEqFD,gBAAA;EACA,2BAAA;AA0uER;AAxuEI;EACI,qCAAA;AA0uER;AAxuEI;EACI,iBAAA;AA0uER;;AAtuEA;EACI,aAAA;AAyuEJ;AAxuEI;;EAEI,cAAA;EACA,eAAA;AA0uER;AAxuEI;EACI,SAAA;AA0uER;;AAvuEA;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;AA0uEJ;;AAxuEA;EACI,eFxHI;EEyHJ,gBF/GK;EEgHL,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,sCAAA;EACA,mBAAA;EACA,iBAAA;AA2uEJ;;AAzuEA;EACI,kBAAA;AA4uEJ;AA3uEI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;EACA,cAAA;EACA,WAAA;EACA,sCAAA;AA6uER;AA3uEI;EACI,8BAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AA6uER;;AAzuEI;ED7JA,6BC8JI;EACA,UAAA;EACA,kBAAA;AA+uER;AA5uEQ;EACI,UAAA;EACA,mBAAA;AA8uEZ;;AA1uEA;EACI,gBAAA;EACA,YAAA;AA6uEJ;;AA1uEA;EACI,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AA6uEJ;;AA3uEA;EACI;IACI,kBAAA;IACA,mBAAA;EA8uEN;AACF","sourcesContent":["/* font size */\n\n$fs-28: 28px;\n$fs-20: 20px;\n$fs-24: 24px;\n$fs-15: 15px;\n$fs-16: 16px;\n$fs-18: 18px;\n$fs-14: 14px;\n$fs-12: 12px;\n\n/* font weight*/\n\n$fw-100: 100;\n$fw-200: 200;\n$fw-300: 300;\n$fw-400: 400;\n$fw-500: 500;\n$fw-600: 600;\n$fw-700: 700;\n$fw-800: 800;\n$fw-900: 900;\n\n/* box shadow*/\n\n$shadow1: -2px 20px 50px -10px rgba(88, 92, 98, 0.12);\n$shadow2: 0px 5px 10px 0px rgba(99, 95, 133, 0.32);\n$shadow3: 0px 25px 50px -12px rgba(0, 0, 0, 0.25);\n$shadow4: 1px 1px 14px 0px rgba(0, 0, 0, 0.15);\n$shadow5: 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.1);\n\n/* radius*/\n\n$rd-32: 32px;\n$rd-14: 14px;\n","@mixin transition($transition...) {\n    -moz-transition: $transition;\n    -o-transition: $transition;\n    -webkit-transition: $transition;\n    transition: $transition;\n}\n@mixin transform($transform...) {\n    -moz-transform: $transform;\n    -o-transform: $transform;\n    -webkit-transform: $transform;\n    transform: $transform;\n}\n\n/* spacer*/\n\n$sizes: 30;\n$font: 20;\n\n@mixin margin-classes {\n    @for $i from 1 through $sizes {\n        $margin: $i * 2px;\n        /* margin #{$margin} */\n        .m#{$i} {\n            margin: $margin;\n        }\n        .ml#{$i} {\n            margin-left: $margin;\n        }\n        .mr#{$i} {\n            margin-right: $margin;\n        }\n        .mt#{$i} {\n            margin-top: $margin;\n        }\n        .mb#{$i} {\n            margin-bottom: $margin;\n        }\n        .mx#{$i} {\n            margin-left: $margin;\n            margin-right: $margin;\n        }\n        .my#{$i} {\n            margin-top: $margin;\n            margin-bottom: $margin;\n        }\n    }\n}\n@include margin-classes;\n\n@mixin padding-classes {\n    @for $i from 1 through $sizes {\n        $padding: $i * 2px;\n        /* padding #{$padding} */\n        .p#{$i} {\n            padding: $padding;\n        }\n        .pl#{$i} {\n            padding-left: $padding;\n        }\n        .pr#{$i} {\n            padding-right: $padding;\n        }\n        .pt#{$i} {\n            padding-top: $padding;\n        }\n        .pb#{$i} {\n            padding-bottom: $padding;\n        }\n        .px#{$i} {\n            padding-left: $padding;\n            padding-right: $padding;\n        }\n        .py#{$i} {\n            padding-top: $padding;\n            padding-bottom: $padding;\n        }\n    }\n}\n@include padding-classes;\n\n/* font size*/\n\n@mixin fontsize-classes {\n    @for $i from 1 through $font {\n        $fontSize: $i * 2px;\n        .fs#{$i} {\n            font-size: $fontSize;\n        }\n    }\n}\n@include fontsize-classes;\n","@import 'variable';\n@import 'mixin';\n@import 'custom';\n\n.layout-inner-wrap {\n    padding: 16px 32px 16px 32px;\n    position: sticky;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    z-index: 9;\n    background-color: var(--white-10);\n    .left-box {\n        flex: 1;\n    }\n}\n.max-w350 {\n    max-width: 350px;\n    width: 100%;\n}\n.custom-dropdown {\n    .dropdown-toggle {\n        background-color: transparent;\n        border-radius: 0px;\n        box-shadow: none;\n        &:after {\n            display: none;\n        }\n    }\n}\n\n.notification-custom {\n    .dropdown-toggle {\n        color: var(--indigo-600);\n        font-size: 24px;\n        padding: 0px;\n        height: 40px;\n        width: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        line-height: 1;\n        i {\n            line-height: 1;\n        }\n        @include transition(300ms ease-in-out);\n        &:active {\n            background-color: transparent !important;\n            color: var(--indigo-800);\n        }\n        &:hover {\n            color: var(--indigo-800);\n        }\n        &:focus-visible {\n            box-shadow: none;\n            outline: none;\n        }\n    }\n}\n\n/* notification */\n\n.notification-custom {\n    .dropdown-menu {\n        border: none;\n        border-radius: 16px;\n        box-shadow: -2px 20px 50px -10px rgba(88, 92, 98, 0.12);\n        padding: 0px;\n        min-width: 395px;\n        margin-top: 8px;\n        &:after {\n            content: '';\n            position: absolute;\n            top: -10px;\n            right: 20px;\n            background-color: var(--white);\n            width: 20px;\n            height: 20px;\n            transform: rotate(45deg);\n            border-radius: 4px;\n        }\n    }\n    .notification-header {\n        padding: 24px 24px 16px 24px;\n    }\n    .message-header {\n        font-size: $fs-14;\n        font-weight: $fw-400;\n        line-height: 1.4;\n        color: var(--cool-grey-800);\n        padding-bottom: 10px;\n        span {\n            line-height: 1;\n        }\n        strong {\n            font-weight: $fw-700;\n        }\n    }\n    .message-detail {\n        font-size: $fs-12;\n        font-weight: $fw-400;\n        line-height: 1.2;\n        color: var(--cool-grey-700);\n    }\n    .unread-meassage {\n        background-color: var(--blue-gray-50);\n    }\n    .notification-footer {\n        padding-top: 10px;\n    }\n}\n\n.notification-body-inner {\n    padding: 16px;\n    .icon-left,\n    .right-icon {\n        flex: 0 0 40px;\n        max-width: 40px;\n    }\n    .center-message {\n        flex: 1;\n    }\n}\n.meesage-time {\n    text-align: center;\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n.message-date {\n    font-size: $fs-12;\n    font-weight: $fw-700;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--cool-grey-500);\n    background-color: var(--cool-grey-200);\n    border-radius: 30px;\n    padding: 4px 10px;\n}\n.meesage-time {\n    position: relative;\n    &:after {\n        content: '';\n        position: absolute;\n        top: 12px;\n        left: 0px;\n        right: 0px;\n        width: calc(100% - 32px);\n        margin: 0 auto;\n        height: 1px;\n        background-color: var(--cool-grey-200);\n    }\n    .message-outer-line {\n        background-color: var(--white);\n        padding: 0 10px;\n        display: inline-block;\n        position: relative;\n        z-index: 1;\n    }\n}\n.notification-body-inner {\n    .cstm-icon-btn {\n        @include transition(300ms ease-in-out);\n        opacity: 0;\n        visibility: hidden;\n    }\n    &:hover {\n        .cstm-icon-btn {\n            opacity: 1;\n            visibility: visible;\n        }\n    }\n}\n.notification-scroll {\n    overflow-y: auto;\n    height: 58vh;\n}\n\n.notification-empty {\n    padding: 0 16px 0 16px;\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n@media only screen and (max-width: 1199px) {\n    .layout-inner-wrap {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n}\n","p {\n    margin-bottom: 0px;\n}\n\n.text-bold-28 {\n    font-weight: $fw-700;\n    font-size: $fs-28;\n    line-height: 1.2;\n}\n.text-semibold-28 {\n    font-weight: $fw-600;\n    font-size: $fs-28;\n}\n\n.text-regular-15 {\n    font-weight: $fw-400;\n    font-size: $fs-15;\n    line-height: 1.4;\n}\n.text-bold-15 {\n    font-weight: $fw-700;\n    font-size: $fs-15;\n    line-height: 1.4;\n}\n.text-semibold-15 {\n    font-weight: $fw-600;\n    font-size: $fs-15;\n    line-height: 1.4;\n}\n\n.text-regular-16 {\n    font-weight: $fw-400;\n    font-size: $fs-16;\n    line-height: 1.4;\n}\n.text-bold-16 {\n    font-weight: $fw-700;\n    font-size: $fs-16;\n    line-height: 1.4;\n}\n.text-semibold-16 {\n    font-weight: $fw-600;\n    font-size: $fs-16;\n    line-height: 1.4;\n}\n\n.text-semibold-18 {\n    font-weight: $fw-600;\n    font-size: $fs-18;\n    line-height: 1.4;\n}\n.text-bold-18 {\n    font-weight: $fw-700;\n    font-size: $fs-18;\n    line-height: 1.4;\n}\n\n.text-bold-20 {\n    font-weight: $fw-700;\n    font-size: $fs-20;\n    line-height: 1.4;\n}\n.text-bold-24 {\n    font-weight: $fw-700;\n    font-size: $fs-24;\n    line-height: 1.4;\n}\n\n.text-regular-14 {\n    font-weight: $fw-400;\n    font-size: $fs-14;\n    line-height: 1.4;\n}\n.text-bold-14 {\n    font-weight: $fw-700;\n    font-size: $fs-14;\n    line-height: 1.4;\n}\n\n.text-regular-12 {\n    font-weight: $fw-400;\n    font-size: $fs-12;\n    line-height: 1.4;\n}\n\n.min-h100vh {\n    min-height: 100vh;\n}\n/* color*/\n.text-white {\n    color: var(--white);\n}\n.text-indigo-50 {\n    color: var(--indigo-50);\n}\n.text-indigo-25 {\n    color: var(--indigo-25);\n}\n.text-indigo-900 {\n    color: var(--indigo-900);\n}\n.text-indigo-800 {\n    color: var(--indigo-800);\n}\n.text-indigo-200 {\n    color: var(--indigo-200);\n}\n.text-indigo-400 {\n    color: var(--indigo-400);\n}\n\n.text-indigo-600 {\n    color: var(--indigo-600);\n}\n.text-cool-grey-800 {\n    color: var(--cool-grey-800);\n}\n.text-cool-grey-200 {\n    color: var(--cool-grey-200);\n}\n.text-cool-grey-500 {\n    color: var(--cool-grey-500);\n}\n.text-cool-grey-100 {\n    color: var(--cool-grey-100);\n}\n.text-cool-grey-600 {\n    color: var(--cool-grey-600);\n}\n.text-cool-grey-400 {\n    color: var(--cool-grey-400);\n}\n\n.text-purpel-graident {\n    color: var(--purpel-graident);\n}\n.text-red-10 {\n    color: var(--red-10);\n}\n.text-red-400 {\n    color: var(--red-400);\n}\n\n.text-green-10 {\n    color: var(--green-10);\n}\n\n.text-yellow-10 {\n    color: var(--yellow-10);\n}\n.bg-gradient-primary {\n    background: var(--purpel-graident);\n}\n.bg-white-10 {\n    background-color: var(--white-10);\n}\n.bg-red-400 {\n    background-color: var(--red-400);\n}\n.bg-green-400 {\n    background-color: var(--green-400);\n}\n.bg-indigo-400 {\n    background-color: var(--indigo-400);\n}\n\n.bg-yellow-10 {\n    background-color: var(--yellow-10);\n}\n.bg-indigo-900 {\n    background-color: var(--indigo-900);\n}\n.bg-cool-grey-400 {\n    background-color: var(--cool-grey-400);\n}\n.bg-yellow-300 {\n    background-color: var(--yellow-300);\n}\n\n/* shadow*/\n.shadow1 {\n    box-shadow: $shadow1;\n}\n.shadow2 {\n    box-shadow: $shadow2;\n}\n.shadow3 {\n    box-shadow: $shadow3;\n}\n.shadow4 {\n    box-shadow: $shadow4;\n}\n.shadow5 {\n    box-shadow: $shadow5;\n}\n\n/* radius */\n.rd-32 {\n    border-radius: 32px;\n}\n.rd-14 {\n    border-radius: 14px;\n}\n.card-wrap {\n    background-color: var(--white);\n}\n.max-w280 {\n    max-width: 280px;\n}\n\n.text-primary-link {\n    color: var(--indigo-600);\n    @include transition(300ms ease-in-out);\n    &:hover {\n        color: var(--indigo-800);\n        @include transition(300ms ease-in-out);\n    }\n}\n\n.icon-box {\n    line-height: 1;\n}\n\n.min-h100v {\n    min-height: 100vh;\n}\n\n.btn-icon {\n    line-height: 1;\n    font-size: 12px;\n    height: 12px;\n}\n.icon-box-next {\n    height: 18px;\n    font-size: 18px;\n}\n.max-w240 {\n    max-width: 240px;\n    width: 100%;\n}\n.card-structure {\n    padding: 16px;\n    background-color: var(--white);\n    border-radius: 16px;\n    box-shadow: none;\n    border: none;\n    min-height: 100%;\n    .current-incentive-box {\n        width: 100%;\n    }\n}\n.card-spacing-24 {\n    padding: 24px;\n}\n.card-incentive-outer {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.w-90 {\n    width: 90px;\n}\n.max-w440 {\n    max-width: 440px;\n    width: 100%;\n}\n\n.min-h100 {\n    min-height: 100%;\n}\n.h-600 {\n    height: 600px;\n}\n.h-border-top {\n    border-color: var(--cool-grey-200);\n    opacity: 1;\n}\n\n.max-h470 {\n    max-height: 470px;\n    overflow-y: auto;\n}\n.max-h556 {\n    max-height: 556px;\n    overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
